/**
 * The sleeping stage owns a scratch solver-contact header. Its high bit makes
 * the low 31-bit count alias the canonical active-contact entries instead of
 * requiring an O(active contacts) copy into scratch.
 */
export const SOLVER_CONTACT_CANONICAL_ALIAS_BIT = 0x80000000;
export const SOLVER_CONTACT_COUNT_MASK = 0x7fffffff;

export type SolverContactListView = {
  count: number;
  entriesOffset: number;
  canonicalAlias: boolean;
};

/** CPU mirror of the WGSL header mask/base selection used by every AVBD lane. */
export function decodeSolverContactListHeader(
  rawHeader: number,
  canonicalHeaderOffset: number,
  solverHeaderOffset: number,
  maxActiveContacts: number,
): SolverContactListView {
  const header = rawHeader >>> 0;
  const canonicalAlias = solverHeaderOffset !== canonicalHeaderOffset
    && (header & SOLVER_CONTACT_CANONICAL_ALIAS_BIT) !== 0;
  return {
    count: Math.min(header & SOLVER_CONTACT_COUNT_MASK, maxActiveContacts),
    entriesOffset: (canonicalAlias ? canonicalHeaderOffset : solverHeaderOffset) + 1,
    canonicalAlias,
  };
}
